import LoginModel from './loginModel'

export default class RegisterModel {
    public prenom = ''
    public nom = ''
    public email = ''
    public password = ''
    public confirmPassword = ''

    public asLoginModel() {
        return new LoginModel({ email: this.email, password: this.password })
    }
}
